import {Box, DialogContent, Stack, Typography, useTheme} from '@mui/material';
import {BaseDialog, BaseList} from '@resurs-internal/mui';
import {useDialog, useTranslate} from 'hooks';
import digitalInvoiceImage from 'assets/images/update-info-sand.png';
import {useCustomer} from '@resurs-internal/rb-app-api';
import {IconBadge} from 'components';
import {useNavigate} from '@tanstack/react-router';
import {analytics} from '@resurs-internal/core';

export const UpdateContactInformationDialog = () => {
  const dialog = useDialog('update-contact-information');
  const theme = useTheme();
  const translate = useTranslate();
  const customer = useCustomer();
  const navigate = useNavigate();

  return (
    <BaseDialog
      PaperProps={{
        sx: {
          background: theme.palette.background.paper,
          maxHeight: {xs: '95%', md: '95%'},
          position: {xs: 'absolute', md: 'relative'},
          borderTopRightRadius: {xs: '20px', md: undefined},
          borderTopLeftRadius: {xs: '20px', md: undefined},
          bottom: 0,
          border: 0,
        },
      }}
      open={dialog.open}
      maxWidth={'sm'}
      actions={[
        {
          title: translate(
            'update-customer-information.notification.change-action',
          ),
          onClick: () => {
            analytics.log('customer_details_change_navigation');
            dialog.onClose();
            navigate({to: '/home/service/profile'});
          },
          color: 'secondary',
        },
        {
          title: translate(
            'update-customer-information.notification.confirm-action',
          ),
          onClick: () => {
            analytics.log('customer_details_confirmed');
            dialog.onClose();
          },
          color: 'primary',
        },
      ]}>
      <DialogContent
        sx={{
          minWidth: {xs: '100%', md: '600px'},
          p: 'unset',
        }}>
        <Box
          component={'img'}
          src={digitalInvoiceImage}
          alt="image_step_image"
          id="image_step_image"
          sx={{
            objectFit: 'cover',
            width: '100%',
            height: '100%',
          }}
        />
        <Stack alignItems={'center'} textAlign={'center'} padding={4} gap={2}>
          <Typography typography={'h4'}>
            {translate('update-customer-information.notification.title')}
          </Typography>
          <Typography typography={'body2'}>
            {translate('update-customer-information.notification.subtitle')}
          </Typography>
          <BaseList
            sx={{width: '100%'}}
            borderless
            items={[
              {
                id: 'email',
                icon: <IconBadge type={'font'} icon={'envelope'} />,
                title: customer.query.data?.email,
              },
              {
                id: 'phone',
                icon: <IconBadge type={'font'} icon={'mobile'} />,
                title: customer.query.data?.mobilePhoneNo,
              },
            ]}
          />
        </Stack>
      </DialogContent>
    </BaseDialog>
  );
};
